import { render, staticRenderFns } from "./CardSuppliers.vue?vue&type=template&id=d8b2d33e&scoped=true&"
import script from "./CardSuppliers.vue?vue&type=script&lang=js&"
export * from "./CardSuppliers.vue?vue&type=script&lang=js&"
import style0 from "./CardSuppliers.vue?vue&type=style&index=0&id=d8b2d33e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b2d33e",
  null
  
)

export default component.exports